import { X, BarChart3, Copy } from "lucide-react";
import { toast } from "sonner";
import { copyToClipboard } from "../lib/clipboard";

export const ShareModal = ({ open, onClose, text, url }) => {
  if (!open) return null;
  const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const doCopy = async () => {
    const ok = await copyToClipboard(`${text}\n\n${url}`);
    toast(ok ? "Copied to clipboard" : "Copy failed — try manually selecting the text", { duration: 2000 });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-[#0a0f1a] border border-white/[0.08] rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl"
        onClick={e => e.stopPropagation()} data-testid="share-modal">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-bold text-slate-200">Share this insight</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-300">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="bg-white/[0.03] border border-white/[0.05] rounded-lg p-3 mb-4 text-xs text-slate-300 leading-relaxed max-h-[120px] overflow-y-auto">
          {text}
        </div>
        <div className="flex gap-2">
          <a href={tweetUrl} target="_blank" rel="noopener noreferrer" data-testid="share-twitter"
            className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-white/[0.05] hover:bg-white/[0.08] border border-white/[0.06] rounded-xl text-xs text-slate-300 transition-all">
            <X className="w-3.5 h-3.5" />X / Twitter
          </a>
          <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" data-testid="share-linkedin"
            className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-white/[0.05] hover:bg-white/[0.08] border border-white/[0.06] rounded-xl text-xs text-slate-300 transition-all">
            <BarChart3 className="w-3.5 h-3.5" />LinkedIn
          </a>
          <button onClick={doCopy} data-testid="share-copy"
            className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-white/[0.05] hover:bg-white/[0.08] border border-white/[0.06] rounded-xl text-xs text-slate-300 transition-all">
            <Copy className="w-3.5 h-3.5" />Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
